module.exports = __webpack_public_path__ + "img/tech_3.bf0b84d8.jpg";